module.exports = __webpack_public_path__ + "static/media/GalleryMain14.d40aba08.jpg";